(function() {
    'use strict';

    angular
        .module('app')
        .factory('HtsFlashEditService',
            function(WebApiService) {

                var routePrefix = '/api/hts';

                return {

                    search: function (searchObject) {
                        return WebApiService.postJson(routePrefix + '/HtsSearch', searchObject, '', false);
                    },

                    updateDetails: function (updateData) {
                        return WebApiService.postJson(routePrefix + '/HtsUpdateDetails', updateData);
                    }
                };

            });
})();
